import React, { useState, useEffect } from "react";
import { Container, Col, Row } from "react-bootstrap";
import { TextInputForm } from "../../components/Forms";
import { ClickButton } from "../../components/ClickButton";
import { useNavigate, useLocation } from "react-router-dom";
import API_DOMAIN from "../../config/config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ExpenseCreation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { type, rowData } = location.state || {};

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    expense_name: "",
    amount: "",
    date: "",
  });

  useEffect(() => {
    if (type === "edit" && rowData) {
      setFormData(rowData);
    }
  }, [type, rowData]);

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      const response = await fetch(`${API_DOMAIN}/expense.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          action: type === "edit" ? "update" : "create",
          ...formData,
        }),
      });
      const responseData = await response.json();
      if (responseData.head.code === 200) {
        setLoading(false);
        setLoading(false);
        toast.success(responseData.head.msg);
        setTimeout(() => navigate("/console/expense"), 1000);
      } else {
        setLoading(false);
        toast.error(responseData.head.msg);
      }
    } catch (error) {
      setLoading(false);
      toast.error("Something went wrong!");

      setLoading(false);
    }
  };

  return (
    <Container fluid>
      <Row>
        <Col lg="12" className="py-3">
          <h2>{type === "edit" ? "Edit Expense" : "Create Expense"}</h2>
        </Col>
        <Col lg="3">
          <TextInputForm
            placeholder="Expense Name"
            name="expense_name"
            value={formData.expense_name}
            onChange={(e) => setFormData({ ...formData, expense_name: e.target.value })}
          />
        </Col>
        <Col lg="3">
          <TextInputForm
            placeholder="Amount"
            name="amount"
            type="number"
            value={formData.amount}
            onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
          />
        </Col>
        <Col lg="3">
          <TextInputForm
            type="date"
            name="date"
            value={formData.date}
            onChange={(e) => setFormData({ ...formData, date: e.target.value })}
          />
        </Col>
        <Col
          lg="12"
          className="py-3 text-center d-flex flex-row justify-content-center gap-3" // Added gap-3
        >
          <div className="d-flex justify-content-center">
            <ClickButton
              label={type === "edit" ? "update" : "Submit"}
              disabled={loading} onClick={handleSubmit}

            />
          </div>
          <div className="d-flex justify-content-center">
            <ClickButton
              label="Cancel"
              onClick={() => navigate("/console/expense")}
            />
          </div>
        </Col>

      </Row>
      <ToastContainer />
    </Container>
  );
};

export default ExpenseCreation;
